import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { AsideToggleDirective } from '../directives';
import { NotificationContainerComponent } from './notification-container/notification-container.component';
import { NotificationComponent } from './notification/notification.component';


@NgModule({
  declarations: [
    NotificationComponent,
    NotificationContainerComponent,
    AsideToggleDirective,
  ],
  exports: [
    NotificationContainerComponent,
    AsideToggleDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    OverlayPanelModule,
    ButtonModule,
  ],
})
export class NotificationsModule { }
